import React, {useContext} from "react";
import {ValidatedValue} from "../../../../helpers/validatedValue";
import "./dateAndTime.scss";
import {TimePicker} from "@mui/lab";
import {observer} from "mobx-react";
import TextInput from "../../../../common/components/shared/textInput/textInput";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import {ClickAwayListener} from "@mui/material";
import {storesContext} from "../../../../common/stores/stores";
import {UserStore} from "../../../../administration/stores/userStore";
import {DateUtils} from "../../../../helpers/dateUtils";

interface TimeProps {
    testId: string;
    timeLabel: string;
    hourValue: ValidatedValue<Date | null>;
    onChangeHour: (date: Date | null) => void;
    disabled?: boolean;
}

function Time(props: TimeProps) {
    const userStore = useContext(storesContext).userStore as UserStore;
    const language = userStore.language;
    const [displayClock, setDisplayClock] = React.useState(false);
    const [timeStep, setTimeStep] = React.useState<"hours" | "minutes" | "seconds">("hours");
    const mask = DateUtils.timeMaskMap[language as keyof typeof DateUtils.timeMaskMap];

    return (
        <ClickAwayListener onClickAway={() => {
            closeClock();
        }}>
            <div className="time">
                <TimePicker
                    disableMaskedInput={false}
                    mask={mask}
                    ampm={language === "en"}
                    label={props.timeLabel}
                    value={props.hourValue.value}
                    onChange={(newTime: Date | null) => {
                        props.hourValue.setValue(newTime);
                        props.onChangeHour(newTime);
                        props.hourValue.clearValidation();
                        if (timeStep === "minutes") {
                            closeClock();
                        }
                    }}
                    onViewChange={(event) => {
                        setTimeStep(event);
                    }}
                    onClose={() => {
                        setTimeStep("hours");
                    }}
                    open={displayClock}
                    renderInput={(params) => (
                        <TextInput
                            params={params}
                            label={props.timeLabel}
                            validatedValue={props.hourValue}
                            endIcon={
                                <AccessTimeIcon/>
                            }
                            onClickEndIcon={() => setDisplayClock(!displayClock)}
                            testId={props.testId}
                            withoutOnChange
                            disabled={props.disabled}
                        />
                    )}
                    disabled={props.disabled}
                />
            </div>
        </ClickAwayListener>
    );

    function closeClock() {
        setDisplayClock(false);
    }
}

export default observer(Time);
